import { RUN_SOURCE_LABEL, RUN_STATUS, toOptions } from "../../features/monitor.constants";

// Advanced filter of the Run log list. Every key must also be in FILTER_FIELDS of the backend's
// reminder_monitor/run_log/controller.js, the whitelist get-all filters on.
export const runLogFilterFields = [
  { key: "status", label: "Status", type: "enum", group: "Run", options: toOptions(RUN_STATUS) },
  { key: "source", label: "Started by", type: "enum", group: "Run", options: toOptions(RUN_SOURCE_LABEL) },
  { key: "rule_fid", label: "Rule", type: "select", group: "Run", optionsKey: "rules", optionLabel: "name", optionValue: "id" },
  { key: "started_at", label: "Started", type: "datetime", group: "Dates" },
  { key: "run_slot", label: "Slot", type: "datetime", group: "Dates" },
];
